import { createContext, useContext } from 'react';

export interface FindingsIssueContextProps {
  getAlerts(options?: { skipIfUnchanged?: boolean });
  getAggregatedFindings();
  severity: Record<string, any>[];
  alertStatus: Record<string, any>;
  alertCategoryOptions: Record<string, any>[];
  alertCategory: Record<string, any>;
  cloud: Record<string, any>;
  resourceTypeOptions: Record<string, any>[];
  resourceType: Record<string, any>[];
  blueprintOptions: Record<string, any>[];
  blueprintId: Record<string, any>;
  updateValue(field, value);
}

export const FindingsIssueContext = createContext<FindingsIssueContextProps>({
  getAlerts: () => {},
  getAggregatedFindings: () => {},
  severity: [],
  alertStatus: {},
  alertCategoryOptions: [],
  alertCategory: {},
  cloud: {},
  resourceTypeOptions: [],
  resourceType: [],
  blueprintOptions: [],
  blueprintId: {},
  updateValue: () => {},
});

export const FindingsIssueContextProvider = FindingsIssueContext.Provider;

export const useFindingsIssueContext = () => useContext(FindingsIssueContext);
